<template>
    
    <div class="content">
        <el-menu
            default-active="vertical"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b">

            <el-menu-item index="1">文本</el-menu-item>
            <el-menu-item index="6">图片</el-menu-item>
            <el-menu-item index="3">素材</el-menu-item>
            <el-menu-item index="2">训练</el-menu-item>
            <!--<el-menu-item index="1">问答</el-menu-item>
            <el-menu-item index="2">聊天</el-menu-item>
            <el-menu-item index="3">代码</el-menu-item>
            <el-menu-item index="4">翻译</el-menu-item>
            <el-menu-item index="5">转换</el-menu-item>
            <el-menu-item index="6">图片</el-menu-item>-->
            <el-menu-item index="7">我的</el-menu-item>
            <!--<el-menu-item index="2"><a href="https://www.ele.me" target="_blank">订单管理</a></el-menu-item>-->
        </el-menu>
    </div>
    
</template>
  
  <script>
  

    export default {
      data() {
        return {
          activeIndex: '1'
        };
      },
      methods: {
        //1问答  2聊天  3代码  4翻译  5转换   6图片
        handleSelect(key, keyPath) {
            if(key == 6){
              this.$router.push({path:"/image",params: {"type": 1}})
            }else if(key == 2){
              this.$router.push({path:"/tune",params: {"type": 1}})
            }else if(key == 3){
              this.$router.push({path:"/tuneFile",params: {"type": 1}})
            }else if(key == 7){
              this.$router.push({path:"/my",params: {"type": 1}})
            }else{
              this.$router.push({path:"/txt",params: {"type": key}})
            }
        },
       
      },
      
    }
  </script>
